import React from 'react'
import OrcaSecurityMappingForm from './OrcaSecurityMappingForm';
import OrcaSecurityCredentialsForm from './OrcaSecurityCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { CellRenderers } from 'utils/tableUtils';
import { isEmpty } from 'lodash';

export default function OrcaSecurityConfigListing(props) {
    const columns = [{
        title: "Account Name",
        dataIndex: "accountName",
        width: 120,
        render: CellRenderers.VALUE_OR_NA,
    }, {
        title: "Ingestion Type",
        dataIndex: "ingestionType",
        width: 120,
        render: (ingestionType) => isEmpty(ingestionType) ? "All" : ingestionType,
    }]
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={OrcaSecurityMappingForm}
            CredentialsForm={OrcaSecurityCredentialsForm}
            triggerModifyParam={triggerModifyParam}
            extraColumns={columns}
            displayComponentName="Account Name"
        />
    )
};

const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
}